import { Page, type PageProps } from '@festina-life/ui/structure'
import cx from 'classnames'
import { useLocation } from 'react-router'

import { useNavigationItems, useScenarioContext } from '../..'
import { LifeErrorFallback } from '../errorFallback/LifeErrorFallback'
import { scenarioStyles } from '../participantOverview/scenarios/scenarioStyles'

type Props = PageProps

export const LifePage = ({ ErrorFallback, ...props }: Props) => {
  const { variantIdentifier } = useScenarioContext()
  const isInScenario = !!variantIdentifier?.scenarioId
  const scenarioBgStyles = isInScenario
    ? cx(
        'bg-primary-50! dark:bg-primary-950!',
        ' **:data-amaze-card:inset-ring-slate-300 dark:**:data-amaze-card:inset-ring-slate-600', // Increase card contrast a bit
      )
    : undefined
  const { pathname } = useLocation()
  const isRouteDefinedWithSupportsScenarios = useNavigationItems()
    .flatMap((item) => item.items ?? [])
    .some(
      ({ action, supportsScenarios }) =>
        action === pathname && supportsScenarios,
    )
  const shouldApplyScenarioStyles =
    isInScenario && isRouteDefinedWithSupportsScenarios

  return (
    <Page
      {...props}
      style={shouldApplyScenarioStyles ? scenarioStyles : undefined}
      sidebarClassName={
        shouldApplyScenarioStyles ? scenarioBgStyles : undefined
      }
      childrenWrapperClassName={
        shouldApplyScenarioStyles ? scenarioBgStyles : undefined
      }
      ErrorFallback={ErrorFallback ?? LifeErrorFallback}
    />
  )
}
